module.exports = __webpack_public_path__ + "static/media/Foreigner_Reservation_Layout.91d8e476.docx";